import { NetworkStatus, useQuery } from '@apollo/client';
import Evaluation1Table from 'components/Tables/Evaluation1';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import { useUser } from 'contexts/userContext';
import {
  GET_USER_BY_ID_QUERY,
  GET_USER_GOALS,
  GetUserByIdResponse,
  GetUserByIdVariables,
  GetUserGoalsResponse,
  GetUserGoalsVariables,
} from 'graphql/query/user';
import { UserStatusEnum } from 'types';
import Evaluation2Table from 'components/Tables/Evaluation2';
import { Grid } from '@mui/material';
import Evaluation3Table from 'components/Tables/Evaluation3';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const SelfEvaluationPage = () => {
  const { user: loggedInUser } = useUser();

  const { data: userGoals, loading: loadingUserGoals } = useQuery<
    GetUserGoalsResponse,
    GetUserGoalsVariables
  >(GET_USER_GOALS, {
    variables: {
      user: loggedInUser?._id as string,
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
  });

  const { data: user, loading: loadingUser } = useQuery<GetUserByIdResponse, GetUserByIdVariables>(
    GET_USER_BY_ID_QUERY,
    {
      variables: {
        user: loggedInUser?._id as string,
        year: getSelectedObjectiveGoalsYear(),
      },
      fetchPolicy: 'network-only',
    }
  );

  const isObjectiveSettingsApproved =
    user?.getUserById?.annualUserInfo?.startYearStatus === UserStatusEnum.APPROVED;

  const currentYear = new Date().getFullYear();
  const selectedYear = getSelectedObjectiveGoalsYear();

  const isRunningYear = currentYear === selectedYear;

  return (
    <Navbar title={`User Goals Settings - ${getSelectedObjectiveGoalsYear()}`}>
      <Grid container rowGap={2} mb={5}>
        {loadingUserGoals || loadingUser ? (
          <LoadingIndicator />
        ) : (
          <>
            <Evaluation1Table
              employee={user?.getUserById!}
              title="My Objective Settings"
              initialRows={!!userGoals!.getUserGoals?.length ? userGoals!.getUserGoals : undefined}
            />
            {(!isRunningYear ||
              (isObjectiveSettingsApproved && user.getUserById.annualUserInfo?.period > 1)) && (
              <Evaluation2Table
                employee={user?.getUserById!}
                title="Mid year review"
                initialRows={
                  !!userGoals!.getUserGoals?.length ? userGoals!.getUserGoals : undefined
                }
              />
            )}
            {(!isRunningYear ||
              (isObjectiveSettingsApproved && user.getUserById.annualUserInfo?.period > 2)) && (
              <Evaluation3Table
                employee={user?.getUserById!}
                title="End year review"
                initialRows={
                  !!userGoals!.getUserGoals?.length ? userGoals!.getUserGoals : undefined
                }
              />
            )}
          </>
        )}
      </Grid>
    </Navbar>
  );
};

export default SelfEvaluationPage;
